import React from "react";

import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";

import SliderPortfolio from "../../components/slider-portfolio/SliderPortfolio";
import HeroSection from "../../components/hero-section/HeroSection";
import ServiceOne from "../../components/services/ServiceOne";
import TitleSection from "../../components/heading/TitleSection";
import PortfolioSwiper from "../../components/portfolio/PortfolioSwiper";
import Testimonial from "../../components/testimonial/Testimonial";
import BlogSwiper from "../../components/blog/BlogSwiper";
import BrandClient from "../../components/brand-client/BrandClient";
import NextPageContent from "../../components/next/NextPageContent";
import Footer from "../../components/footer/Footer";
import HeroSectionTow from "../../components/hero-section/HeroSectionTow";

const MainDemo = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Mystirien – Celtic-Fantasy Music & Art</title>
        <meta
          property="og:title"
          content="Mystirien – Celtic-Fantasy Music & Art"
        />
        <meta
          property="og:description"
          content="Explore the mystical world of Mystirien, a Celtic-fantasy artist creating music and art full of atmosphere and wonder."
        />
        <meta property="og:url" content="https://mystirien.com/" />
        <meta
          property="og:image"
          content="https://mystirien.com/assets/img/mystirien-og.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      {/*Start Slider Portfolio*/}
      <SliderPortfolio tag="header" className="mb-section" />
      {/*End Slider Portfolio*/}

      {/*Start Hero Section*/}
      <Container className="section-margin dsn-right-container">
        <HeroSection />
      </Container>
      {/*End Hero Section*/}

      {/*Start Service Section*/}
      <Container className="section-margin">
        <TitleSection description="Adventures">What I Create</TitleSection>
        <ServiceOne
          className="text-center"
          col={3}
          colMobile={1}
          colGap={0}
          colGapTablet={30}
        />
      </Container>
      {/*End Service Section*/}

      {/*Start Box Right Info*/}
      <HeroSectionTow className="section-margin text-center" />
      {/*End Box Right Info*/}

      {/*Start Portfolio Swiper*/}
      <Container as={TitleSection} description="adventures">
        My Magical Journeys
      </Container>
      <PortfolioSwiper grabCursor />
      {/*End Portfolio Swiper*/}

      {/*Start Testimonial*/}
      <Container className="section-margin">
        <Testimonial
          autoHeight
          loop
          grabCursor
          title="Whispers of the Realms"
        />
      </Container>
      {/*End Testimonial*/}

      {/*Start Blog*/}
      <Container className="section-margin dsn-right-container">
        <TitleSection description="Recent Tales">
          Where the Journey Leads
        </TitleSection>
        <BlogSwiper grabCursor loop autoHeight />
      </Container>
      {/*End Blog*/}

      {/*Start Brand*/}
      <Container className="section-margin">
        <TitleSection description="Contact">
          Follow me on my magical journeys
        </TitleSection>
        <BrandClient col={3} colTablet={2} colGap={2} rowGap={2} />
      </Container>
      {/*End Brand*/}

      <NextPageContent className="section-margin" />
      <Footer />
    </React.Fragment>
  );
};

export default MainDemo;
